import api from '../setup/axios';
import config from '../setup/config';

export default {
    getBadEmailsFilterByClient: async (clientId) => {
        const path = `${config.microservices.chatApi}/lead-settings/bad-emails-filter?clientId=${clientId}`;
        const { data } = await api.get(path);

        return data;
    },
    toggleBadEmailsFilterByClient: async (clientId) => {
        const path = `${config.microservices.chatApi}/lead-settings/bad-emails-filter/toggle?clientId=${clientId}`;
        await api.post(path);
    }
}
